import { useEffect, useRef, useState } from 'react';
import { loadCalendly } from './loadCalendly';

const CALENDLY_BASE = 'https://calendly.com/michael94ellis/30min';

function buildCalendlyUrl(isDark) {
  const params = new URLSearchParams({ hide_gdpr_banner: '1' });

  if (isDark) {
    params.set('background_color', '1a1a1a');
    params.set('text_color', 'ffffff');
    params.set('primary_color', '6366f1');
  } else {
    params.set('background_color', 'f5f5f5');
    params.set('text_color', '2c3e50');
    params.set('primary_color', '4a5366');
  }

  return `${CALENDLY_BASE}?${params.toString()}`;
}

function styleCalendlyIframe(container) {
  const iframe = container?.querySelector('iframe');
  if (!iframe) {
    return false;
  }

  iframe.style.background = 'transparent';
  iframe.style.border = '0';
  iframe.style.borderRadius = '16px';
  iframe.style.colorScheme = 'light';

  return true;
}

function CalendlyInlineWidget() {
  const containerRef = useRef(null);
  const [isDark, setIsDark] = useState(() =>
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );

  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = (event) => setIsDark(event.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  useEffect(() => {
    let active = true;
    let observer;
    const container = containerRef.current;

    if (!container) {
      return undefined;
    }

    container.innerHTML = '';

    loadCalendly()
      .then((Calendly) => {
        if (!active || !container) {
          return;
        }

        Calendly.initInlineWidget({
          url: buildCalendlyUrl(isDark),
          parentElement: container,
        });

        observer = new MutationObserver(() => {
          if (styleCalendlyIframe(container)) {
            observer.disconnect();
          }
        });
        observer.observe(container, { childList: true, subtree: true });

        if (!styleCalendlyIframe(container)) {
          window.setTimeout(() => styleCalendlyIframe(container), 500);
        }
      })
      .catch(() => {});

    return () => {
      active = false;
      observer?.disconnect();
      if (container) {
        container.innerHTML = '';
      }
    };
  }, [isDark]);

  return (
    <div
      className="calendly-booking-embed"
      ref={containerRef}
      style={{ minWidth: '320px', height: '700px' }}
    />
  );
}

export default CalendlyInlineWidget;
